import { anton } from '@/lib/font';
import clsx from 'clsx';
import styles from './SectionTitle.module.scss';

type Direction = 'horizontal' | 'vertical';

function SectionTitle({
  englishLabel,
  japaneseLabel,
  direction = 'horizontal',
}: {
  /** 黒バッジ内の英字ラベル（例: "USER DESIGNS", "LINE UP"） */
  englishLabel: string;
  /** 日本語ラベル（例: "みんなのデザイン", "作品一覧"）。バッジのみ表示したい場合は省略 */
  japaneseLabel?: string;
  /** ラベル配置: horizontal=セクション内見出し / vertical=ページ上部の大きい見出し */
  direction?: Direction;
}) {
  const isVertical = direction === 'vertical';
  return (
    <div className={isVertical ? styles.containerVertical : styles.containerHorizontal}>
      <span className={clsx(isVertical ? styles.badgeVertical : styles.badgeHorizontal, anton.className)}>
        {englishLabel}
      </span>
      {japaneseLabel && (
        <span className={isVertical ? styles.labelVertical : styles.labelHorizontal}>{japaneseLabel}</span>
      )}
    </div>
  );
}

export default SectionTitle;
